import React from 'react';
const IconNavBell = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M18 11V16L20 18V19H4V18L6 16V11C6 7.92 7.63 5.36 10.5 4.68V4C10.5 3.17 11.17 2.5 12 2.5C12.83 2.5 13.5 3.17 13.5 4V4.68C16.36 5.36 18 7.93 18 11ZM14 20C14 21.1 13.1 22 12 22C10.89 22 10 21.1 10 20H14Z" fill="#666666"/>
</svg>
);
};
export default IconNavBell;